import {ECurrency} from "../store/currency/types";

const getCurrency = (value: ECurrency): keyof typeof ECurrency => {
    return value === ECurrency.USD ? "USD" : value === ECurrency.UAH ? "UAH" : "EUR";
};

export default getCurrency;
